package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Flower: ImageVector
    get() {
        if (_Flower != null) {
            return _Flower!!
        }
        _Flower = ImageVector.Builder(
            name = "Flower",
            defaultWidth = 95.1.dp,
            defaultHeight = 153.96.dp,
            viewportWidth = 95.1f,
            viewportHeight = 153.96f
        ).apply {
            path(fill = SolidColor(Color(0xFF72E55A))) {
                moveTo(47.61f, 55.49f)
                curveTo(51.99f, 54.38f, 57.48f, 56.99f, 57.59f, 80.03f)
                curveTo(57.69f, 103.07f, 56.74f, 106.08f, 50.19f, 105.49f)
                curveTo(43.64f, 104.89f, 41.33f, 98.83f, 41.28f, 82.6f)
                curveTo(41.23f, 66.46f, 38.62f, 57.76f, 47.61f, 55.49f)
                close()
            }
            path(fill = SolidColor(Color(0xFF6DCC52))) {
                moveTo(50.19f, 105.49f)
                curveTo(48.35f, 105.32f, 46.85f, 104.72f, 45.64f, 103.6f)
                curveTo(45.77f, 103.61f, 45.9f, 103.63f, 46.03f, 103.64f)
                curveTo(52.58f, 104.24f, 53.53f, 101.22f, 53.42f, 78.18f)
                curveTo(53.36f, 64.56f, 51.41f, 58.08f, 48.93f, 55.28f)
                curveTo(53.02f, 55.09f, 57.49f, 59.26f, 57.59f, 80.03f)
                curveTo(57.69f, 103.07f, 56.74f, 106.08f, 50.19f, 105.49f)
                close()
            }
            path(fill = SolidColor(Color(0xFF90FF7D))) {
                moveTo(44.42f, 60.35f)
                curveTo(45.16f, 59.69f, 46.43f, 59.33f, 47.41f, 59.76f)
                curveTo(47.83f, 59.95f, 48.15f, 60.26f, 48.4f, 60.6f)
                curveTo(49.49f, 62.09f, 49.17f, 63.96f, 48.99f, 65.68f)
                curveTo(48.03f, 74.67f, 51.96f, 84.08f, 48.49f, 92.62f)
                curveTo(48.06f, 93.69f, 47.09f, 94.92f, 45.74f, 94.71f)
                curveTo(44.37f, 94.48f, 44.02f, 93.03f, 43.98f, 91.89f)
                curveTo(43.79f, 86.31f, 43.59f, 80.72f, 43.4f, 75.14f)
                curveTo(43.3f, 72.35f, 43.2f, 69.56f, 43.1f, 66.76f)
                curveTo(43.02f, 64.5f, 42.4f, 62.15f, 44.42f, 60.35f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(46f, 62.48f)
                curveTo(46.16f, 62.94f, 46.07f, 63.43f, 46f, 63.9f)
                curveTo(45.43f, 67.6f, 45.76f, 71.37f, 46.05f, 75.1f)
                curveTo(46.12f, 75.95f, 46.17f, 76.86f, 45.63f, 77.58f)
                curveTo(45.44f, 77.84f, 45.1f, 78.08f, 44.75f, 77.98f)
                curveTo(44.36f, 77.88f, 44.28f, 77.47f, 44.27f, 77.14f)
                curveTo(44.16f, 73.76f, 44.04f, 70.38f, 43.93f, 67.01f)
                curveTo(43.89f, 65.6f, 43.57f, 64.05f, 43.67f, 62.67f)
                curveTo(43.76f, 61.48f, 46.04f, 61.18f, 46f, 62.48f)
                close()
            }
            path(fill = SolidColor(Color(0xFF72E55A))) {
                moveTo(49.07f, 103.89f)
                curveTo(53.45f, 102.78f, 58.94f, 105.4f, 59.05f, 128.43f)
                curveTo(59.15f, 151.47f, 58.2f, 154.49f, 51.65f, 153.89f)
                curveTo(45.1f, 153.29f, 42.79f, 147.24f, 42.74f, 131f)
                curveTo(42.7f, 114.86f, 40.08f, 106.16f, 49.07f, 103.89f)
                close()
            }
            path(fill = SolidColor(Color(0xFF6DCC52))) {
                moveTo(51.65f, 153.89f)
                curveTo(49.82f, 153.72f, 48.31f, 153.13f, 47.1f, 152f)
                curveTo(47.23f, 152.02f, 47.36f, 152.03f, 47.49f, 152.04f)
                curveTo(54.04f, 152.64f, 54.99f, 149.62f, 54.89f, 126.59f)
                curveTo(54.82f, 112.96f, 52.88f, 106.48f, 50.39f, 103.69f)
                curveTo(54.48f, 103.49f, 58.95f, 107.66f, 59.05f, 128.43f)
                curveTo(59.15f, 151.47f, 58.2f, 154.49f, 51.65f, 153.89f)
                close()
            }
            path(fill = SolidColor(Color(0xFF90FF7D))) {
                moveTo(45.88f, 108.75f)
                curveTo(46.63f, 108.09f, 47.89f, 107.73f, 48.87f, 108.16f)
                curveTo(49.29f, 108.35f, 49.62f, 108.66f, 49.86f, 109f)
                curveTo(50.95f, 110.5f, 50.63f, 112.36f, 50.45f, 114.08f)
                curveTo(49.5f, 123.07f, 53.42f, 132.49f, 49.95f, 141.02f)
                curveTo(49.52f, 142.09f, 48.55f, 143.33f, 47.2f, 143.11f)
                curveTo(45.83f, 142.89f, 45.48f, 141.43f, 45.44f, 140.29f)
                curveTo(45.25f, 134.71f, 45.05f, 129.12f, 44.86f, 123.54f)
                curveTo(44.76f, 120.75f, 44.66f, 117.96f, 44.56f, 115.17f)
                curveTo(44.48f, 112.91f, 43.86f, 110.55f, 45.88f, 108.75f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(47.47f, 110.89f)
                curveTo(47.62f, 111.35f, 47.53f, 111.83f, 47.46f, 112.3f)
                curveTo(46.9f, 116.01f, 47.23f, 119.77f, 47.52f, 123.5f)
                curveTo(47.58f, 124.35f, 47.63f, 125.26f, 47.09f, 125.98f)
                curveTo(46.9f, 126.24f, 46.56f, 126.48f, 46.21f, 126.39f)
                curveTo(45.82f, 126.28f, 45.74f, 125.87f, 45.73f, 125.54f)
                curveTo(45.62f, 122.16f, 45.51f, 118.79f, 45.39f, 115.41f)
                curveTo(45.35f, 114.01f, 45.03f, 112.46f, 45.13f, 111.07f)
                curveTo(45.22f, 109.88f, 47.5f, 109.58f, 47.47f, 110.89f)
                close()
            }
            path(fill = SolidColor(Color(0xFF569B40))) {
                moveTo(45.17f, 100.22f)
                curveTo(46.8f, 101.82f, 48.81f, 103.01f, 50.98f, 103.65f)
                curveTo(49.63f, 104.23f, 48.23f, 104.85f, 47.33f, 106.04f)
                curveTo(46.59f, 107.01f, 46.29f, 108.25f, 45.8f, 109.38f)
                curveTo(45.31f, 110.51f, 44.5f, 111.63f, 43.32f, 111.87f)
                curveTo(43.2f, 111.89f, 43.08f, 111.91f, 42.98f, 111.86f)
                curveTo(42.79f, 111.77f, 42.73f, 111.53f, 42.69f, 111.32f)
                curveTo(42.23f, 108.55f, 42.38f, 105.72f, 42.53f, 102.91f)
                curveTo(42.58f, 101.94f, 42.31f, 99.98f, 42.91f, 99.17f)
                curveTo(43.61f, 98.21f, 44.61f, 99.67f, 45.17f, 100.22f)
                close()
            }
            path(fill = SolidColor(Color(0xFF72E55A))) {
                moveTo(44.85f, 105.17f)
                curveTo(47.44f, 105.34f, 44.85f, 98.3f, 39.39f, 95.03f)
                curveTo(25.32f, 86.58f, 6.12f, 82.23f, 3.54f, 97.37f)
                curveTo(0.96f, 112.51f, 23.89f, 114.69f, 32.71f, 114.69f)
                curveTo(44.85f, 114.69f, 49.1f, 105.8f, 44.85f, 105.17f)
                curveTo(40.61f, 104.55f, 32.16f, 105.94f, 26.02f, 104.54f)
                curveTo(19.88f, 103.13f, 18.12f, 101.51f, 18.12f, 99.55f)
                curveTo(18.12f, 97.88f, 24.04f, 97.84f, 27.69f, 100.64f)
                curveTo(36.05f, 107.04f, 44.85f, 105.17f, 44.85f, 105.17f)
                close()
            }
            path(fill = SolidColor(Color(0xFF6DCC52))) {
                moveTo(32.71f, 114.69f)
                curveTo(44.85f, 114.69f, 49.1f, 105.8f, 44.85f, 105.17f)
                curveTo(46.95f, 105.31f, 45.64f, 100.7f, 42.15f, 97.2f)
                curveTo(42.6f, 97.92f, 43.74f, 100.58f, 40.34f, 101.27f)
                curveTo(39.26f, 101.49f, 38.16f, 101.62f, 37.08f, 101.39f)
                curveTo(33.83f, 100.69f, 31f, 98.71f, 28.05f, 97.13f)
                curveTo(25.1f, 95.55f, 21.68f, 94.34f, 18.49f, 95.34f)
                curveTo(17.38f, 95.68f, 16.23f, 96.47f, 16.09f, 97.66f)
                curveTo(15.92f, 99.18f, 17.17f, 100.43f, 18.82f, 101.42f)
                curveTo(18.32f, 100.83f, 18.12f, 100.21f, 18.12f, 99.55f)
                curveTo(18.12f, 97.88f, 24.04f, 97.84f, 27.69f, 100.64f)
                curveTo(30.61f, 102.88f, 34.23f, 104.73f, 37.76f, 105.1f)
                curveTo(38.45f, 105.02f, 38.68f, 104.71f, 39.55f, 104.31f)
                curveTo(41.43f, 103.44f, 42.77f, 103.59f, 44.13f, 105.19f)
                curveTo(42.84f, 106.86f, 40.86f, 107.79f, 38.88f, 108.41f)
                curveTo(33.14f, 110.22f, 27.68f, 110.8f, 21.71f, 110.04f)
                curveTo(16.78f, 109.41f, 8.87f, 108.38f, 6.14f, 104.12f)
                curveTo(5.11f, 102.5f, 3.92f, 100.73f, 3.8f, 96.13f)
                curveTo(3.7f, 96.53f, 3.61f, 96.94f, 3.54f, 97.37f)
                curveTo(0.96f, 112.51f, 23.89f, 114.69f, 32.71f, 114.69f)
                close()
            }
            path(fill = SolidColor(Color(0xFF90FF7D))) {
                moveTo(6.52f, 100.83f)
                curveTo(8.19f, 104.12f, 11.98f, 106.01f, 15.57f, 105.64f)
                curveTo(15.92f, 105.6f, 16.31f, 105.52f, 16.54f, 105.24f)
                curveTo(16.82f, 104.86f, 16.7f, 104.32f, 16.53f, 103.88f)
                curveTo(15.99f, 102.49f, 15.07f, 101.28f, 14.45f, 99.92f)
                curveTo(13.83f, 98.56f, 13.55f, 96.89f, 14.3f, 95.6f)
                curveTo(14.94f, 94.49f, 16.19f, 93.93f, 17.4f, 93.58f)
                curveTo(20.57f, 92.65f, 24.02f, 92.77f, 27.13f, 93.89f)
                curveTo(28.35f, 94.33f, 29.53f, 94.93f, 30.81f, 95.12f)
                curveTo(31.23f, 95.18f, 31.71f, 95.18f, 31.99f, 94.86f)
                curveTo(32.32f, 94.5f, 32.2f, 93.88f, 31.87f, 93.52f)
                curveTo(31.53f, 93.16f, 25.23f, 89.76f, 21.71f, 89.23f)
                curveTo(19.19f, 88.84f, 13.62f, 88f, 8.6f, 90.81f)
                curveTo(5.43f, 92.59f, 5.04f, 97.9f, 6.52f, 100.83f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(8.7f, 99.78f)
                curveTo(9.31f, 100.38f, 10.3f, 100.82f, 10.99f, 100.31f)
                curveTo(11.71f, 99.78f, 11.59f, 98.66f, 11.42f, 97.77f)
                curveTo(11.25f, 96.89f, 11.11f, 96f, 11.21f, 95.11f)
                curveTo(11.31f, 94.22f, 11.68f, 93.34f, 12.37f, 92.79f)
                curveTo(12.89f, 92.39f, 13.56f, 92.19f, 14.02f, 91.72f)
                curveTo(15.69f, 90.03f, 12.91f, 90.01f, 11.98f, 90.24f)
                curveTo(10.97f, 90.49f, 9.99f, 90.74f, 9.21f, 91.47f)
                curveTo(6.92f, 93.61f, 6.33f, 97.47f, 8.7f, 99.78f)
                close()
            }
            path(fill = SolidColor(Color(0xFF569B40))) {
                moveTo(51.41f, 106.59f)
                curveTo(51.68f, 107.78f, 52.13f, 109.06f, 52.42f, 110.24f)
                curveTo(53.15f, 113.17f, 55.31f, 113.78f, 58.07f, 114.78f)
                curveTo(57.87f, 112.07f, 57.5f, 111.28f, 56.59f, 108.73f)
                curveTo(56.19f, 107.62f, 55.73f, 106.53f, 55.46f, 105.38f)
                curveTo(55.14f, 103.96f, 54.62f, 101.22f, 54.62f, 99.76f)
                curveTo(53.83f, 100.07f, 53.29f, 101.57f, 52.65f, 102.14f)
                curveTo(51.74f, 102.94f, 51.2f, 103.74f, 50.04f, 103.8f)
                curveTo(51.02f, 104.48f, 51.15f, 105.39f, 51.41f, 106.59f)
                close()
            }
            path(fill = SolidColor(Color(0xFF72E55A))) {
                moveTo(53.82f, 104.73f)
                curveTo(51.23f, 105.01f, 53.56f, 97.87f, 58.89f, 94.38f)
                curveTo(72.63f, 85.37f, 91.64f, 80.25f, 94.8f, 95.28f)
                curveTo(97.96f, 110.3f, 75.12f, 113.41f, 66.31f, 113.76f)
                curveTo(54.18f, 114.25f, 49.6f, 105.53f, 53.82f, 104.73f)
                curveTo(58.04f, 103.94f, 66.53f, 104.99f, 72.61f, 103.34f)
                curveTo(78.69f, 101.69f, 80.39f, 100f, 80.31f, 98.05f)
                curveTo(80.25f, 96.38f, 74.34f, 96.58f, 70.79f, 99.52f)
                curveTo(62.68f, 106.25f, 53.82f, 104.73f, 53.82f, 104.73f)
                close()
            }
            path(fill = SolidColor(Color(0xFF6DCC52))) {
                moveTo(66.31f, 113.76f)
                curveTo(54.18f, 114.25f, 49.6f, 105.53f, 53.82f, 104.73f)
                curveTo(51.72f, 104.95f, 52.86f, 100.29f, 56.21f, 96.66f)
                curveTo(55.79f, 97.39f, 54.75f, 100.1f, 58.17f, 100.65f)
                curveTo(59.26f, 100.83f, 60.37f, 100.92f, 61.44f, 100.64f)
                curveTo(64.66f, 99.81f, 67.41f, 97.72f, 70.3f, 96.03f)
                curveTo(73.18f, 94.33f, 76.56f, 92.98f, 79.78f, 93.85f)
                curveTo(80.9f, 94.15f, 82.09f, 94.89f, 82.27f, 96.07f)
                curveTo(82.5f, 97.58f, 81.3f, 98.89f, 79.68f, 99.94f)
                curveTo(80.16f, 99.33f, 80.34f, 98.7f, 80.31f, 98.05f)
                curveTo(80.25f, 96.38f, 74.34f, 96.58f, 70.79f, 99.52f)
                curveTo(67.95f, 101.88f, 64.41f, 103.87f, 60.89f, 104.37f)
                curveTo(60.21f, 104.32f, 59.97f, 104.03f, 59.08f, 103.66f)
                curveTo(57.16f, 102.87f, 55.83f, 103.07f, 54.54f, 104.72f)
                curveTo(55.89f, 106.34f, 57.9f, 107.19f, 59.9f, 107.74f)
                curveTo(65.71f, 109.31f, 71.19f, 109.67f, 77.12f, 108.67f)
                curveTo(82.02f, 107.84f, 89.89f, 106.5f, 92.45f, 102.12f)
                curveTo(93.42f, 100.47f, 94.55f, 98.66f, 94.49f, 94.05f)
                curveTo(94.61f, 94.44f, 94.71f, 94.85f, 94.8f, 95.28f)
                curveTo(97.96f, 110.3f, 75.12f, 113.41f, 66.31f, 113.76f)
                close()
            }
            path(fill = SolidColor(Color(0xFF90FF7D))) {
                moveTo(91.95f, 98.86f)
                curveTo(90.41f, 102.21f, 86.69f, 104.25f, 83.09f, 104.02f)
                curveTo(82.74f, 104f, 82.34f, 103.94f, 82.11f, 103.66f)
                curveTo(81.81f, 103.3f, 81.91f, 102.75f, 82.06f, 102.3f)
                curveTo(82.56f, 100.89f, 83.43f, 99.65f, 84f, 98.27f)
                curveTo(84.56f, 96.88f, 84.78f, 95.2f, 83.98f, 93.94f)
                curveTo(83.3f, 92.86f, 82.03f, 92.35f, 80.81f, 92.04f)
                curveTo(77.6f, 91.25f, 74.16f, 91.5f, 71.1f, 92.75f)
                curveTo(69.89f, 93.24f, 68.73f, 93.88f, 67.46f, 94.13f)
                curveTo(67.05f, 94.21f, 66.57f, 94.22f, 66.27f, 93.92f)
                curveTo(65.93f, 93.57f, 66.02f, 92.94f, 66.34f, 92.57f)
                curveTo(66.66f, 92.19f, 72.83f, 88.55f, 76.33f, 87.87f)
                curveTo(78.83f, 87.39f, 84.37f, 86.32f, 89.49f, 88.93f)
                curveTo(92.73f, 90.58f, 93.32f, 95.87f, 91.95f, 98.86f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(89.74f, 97.9f)
                curveTo(89.14f, 98.52f, 88.18f, 99f, 87.47f, 98.52f)
                curveTo(86.73f, 98.02f, 86.8f, 96.89f, 86.94f, 95.99f)
                curveTo(87.07f, 95.11f, 87.18f, 94.21f, 87.05f, 93.33f)
                curveTo(86.91f, 92.45f, 86.51f, 91.58f, 85.8f, 91.06f)
                curveTo(85.27f, 90.68f, 84.59f, 90.51f, 84.11f, 90.06f)
                curveTo(82.38f, 88.44f, 85.15f, 88.3f, 86.1f, 88.49f)
                curveTo(87.11f, 88.7f, 88.1f, 88.92f, 88.91f, 89.61f)
                curveTo(91.28f, 91.66f, 92.01f, 95.49f, 89.74f, 97.9f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE874DA))) {
                moveTo(41f, 37.27f)
                curveTo(43.89f, 38.97f, 43.41f, 42.11f, 41.96f, 44.31f)
                curveTo(40.17f, 47.02f, 29.94f, 48.66f, 16.82f, 45.35f)
                curveTo(2.04f, 41.61f, -3.68f, 27.85f, 2.4f, 18.04f)
                curveTo(9.16f, 7.12f, 23.71f, 8.99f, 34.48f, 15.58f)
                curveTo(45.25f, 22.17f, 47.56f, 30.36f, 47.23f, 33.29f)
                curveTo(46.88f, 36.43f, 45.38f, 38.97f, 41f, 37.27f)
                curveTo(36.62f, 35.57f, 36.96f, 30.12f, 29.7f, 26.48f)
                curveTo(21.89f, 22.56f, 17.6f, 23.61f, 16.27f, 26.32f)
                curveTo(14.7f, 29.5f, 17.06f, 33.38f, 25.43f, 35.53f)
                curveTo(33.8f, 37.68f, 36.71f, 34.75f, 41f, 37.27f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC465BD))) {
                moveTo(47.23f, 33.29f)
                curveTo(47.4f, 31.77f, 46.86f, 28.85f, 44.82f, 25.47f)
                curveTo(44.77f, 25.53f, 44.73f, 25.59f, 44.69f, 25.65f)
                curveTo(44.59f, 25.86f, 44.59f, 26.11f, 44.6f, 26.34f)
                curveTo(44.67f, 27.78f, 45f, 29.24f, 44.69f, 30.65f)
                curveTo(44.38f, 32.05f, 43.11f, 33.41f, 41.69f, 33.15f)
                curveTo(41.01f, 33.03f, 40.45f, 32.56f, 39.96f, 32.07f)
                curveTo(37.91f, 30f, 36.68f, 27.26f, 34.83f, 25.01f)
                curveTo(32.61f, 22.29f, 29.44f, 20.41f, 26.04f, 19.59f)
                curveTo(23.02f, 18.85f, 19.57f, 18.86f, 16.66f, 20.06f)
                curveTo(13.99f, 21.16f, 12.55f, 24.33f, 14.3f, 26.93f)
                curveTo(14.69f, 27.5f, 15.21f, 27.91f, 15.81f, 28.22f)
                curveTo(15.81f, 27.57f, 15.97f, 26.93f, 16.27f, 26.32f)
                curveTo(17.6f, 23.61f, 21.89f, 22.56f, 29.7f, 26.48f)
                curveTo(36.01f, 29.64f, 36.58f, 34.17f, 39.49f, 36.42f)
                curveTo(39.52f, 36.44f, 39.54f, 36.45f, 39.57f, 36.47f)
                curveTo(39.55f, 36.47f, 39.54f, 36.46f, 39.53f, 36.45f)
                curveTo(39.67f, 36.56f, 39.82f, 36.66f, 39.98f, 36.76f)
                curveTo(38.6f, 36.19f, 37.31f, 36.13f, 35.86f, 36.2f)
                curveTo(35.95f, 36.28f, 36.06f, 36.35f, 36.16f, 36.42f)
                curveTo(36.97f, 36.89f, 37.89f, 37.16f, 38.66f, 37.7f)
                curveTo(39.43f, 38.23f, 40.04f, 39.17f, 39.79f, 40.07f)
                curveTo(39.52f, 41.04f, 38.44f, 41.5f, 37.47f, 41.75f)
                curveTo(32.96f, 42.9f, 28.19f, 42.33f, 23.62f, 41.43f)
                curveTo(18.74f, 40.46f, 13.85f, 39.08f, 9.72f, 36.32f)
                curveTo(5.59f, 33.56f, 2.53f, 31.76f, 0.85f, 21.29f)
                curveTo(-2.36f, 30.67f, 3.61f, 42.01f, 16.82f, 45.35f)
                curveTo(29.94f, 48.66f, 40.17f, 47.02f, 41.96f, 44.31f)
                curveTo(43.41f, 42.11f, 43.89f, 38.97f, 41f, 37.27f)
                curveTo(45.38f, 38.97f, 46.88f, 36.43f, 47.23f, 33.29f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFF99F8))) {
                moveTo(6.9f, 16.21f)
                curveTo(5.09f, 18.49f, 4.19f, 21.42f, 4.21f, 24.32f)
                curveTo(4.22f, 27.03f, 5.18f, 29.97f, 7.53f, 31.38f)
                curveTo(8.77f, 32.12f, 10.65f, 32.2f, 11.4f, 30.99f)
                curveTo(12.03f, 29.95f, 11.5f, 28.64f, 11.09f, 27.49f)
                curveTo(10.42f, 25.58f, 10.15f, 23.5f, 10.63f, 21.56f)
                curveTo(11.12f, 19.61f, 12.44f, 17.82f, 14.3f, 17.03f)
                curveTo(16.23f, 16.22f, 18.44f, 16.54f, 20.54f, 16.66f)
                curveTo(21.31f, 16.71f, 22.24f, 16.64f, 22.6f, 15.96f)
                curveTo(23.05f, 15.12f, 22.18f, 14.16f, 21.34f, 13.67f)
                curveTo(16.52f, 10.82f, 10.37f, 11.86f, 6.9f, 16.21f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(10.46f, 14.96f)
                curveTo(10.19f, 14.88f, 9.9f, 15.03f, 9.66f, 15.18f)
                curveTo(6.59f, 17.15f, 5.07f, 21.22f, 5.64f, 24.73f)
                curveTo(5.76f, 25.42f, 5.96f, 26.16f, 6.49f, 26.62f)
                curveTo(7.03f, 27.08f, 7.98f, 27.11f, 8.36f, 26.51f)
                curveTo(8.56f, 26.18f, 8.55f, 25.77f, 8.52f, 25.38f)
                curveTo(8.49f, 24.71f, 8.45f, 24.04f, 8.41f, 23.37f)
                curveTo(8.31f, 21.63f, 8.24f, 19.78f, 9.15f, 18.29f)
                curveTo(9.48f, 17.74f, 9.92f, 17.28f, 10.35f, 16.8f)
                curveTo(10.59f, 16.53f, 10.85f, 16.23f, 10.92f, 15.86f)
                curveTo(10.99f, 15.5f, 10.82f, 15.06f, 10.46f, 14.96f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE874DA))) {
                moveTo(43.33f, 45.99f)
                curveTo(45.57f, 43.49f, 48.55f, 44.58f, 50.42f, 46.44f)
                curveTo(52.72f, 48.73f, 52.29f, 59.09f, 46.44f, 71.29f)
                curveTo(39.84f, 85.04f, 25.22f, 87.91f, 16.81f, 80f)
                curveTo(7.45f, 71.21f, 12.17f, 57.32f, 20.77f, 48.07f)
                curveTo(29.37f, 38.83f, 37.86f, 38.19f, 40.66f, 39.09f)
                curveTo(43.67f, 40.06f, 45.86f, 42.03f, 43.33f, 45.99f)
                curveTo(40.79f, 49.95f, 35.51f, 48.53f, 30.5f, 54.92f)
                curveTo(25.11f, 61.8f, 25.29f, 66.21f, 27.68f, 68.05f)
                curveTo(30.49f, 70.23f, 34.76f, 68.67f, 38.52f, 60.9f)
                curveTo(42.29f, 53.12f, 40f, 49.69f, 43.33f, 45.99f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC465BD))) {
                moveTo(40.66f, 39.09f)
                curveTo(39.21f, 38.63f, 36.24f, 38.57f, 32.52f, 39.91f)
                curveTo(32.56f, 39.96f, 32.61f, 40.02f, 32.67f, 40.06f)
                curveTo(32.86f, 40.2f, 33.1f, 40.25f, 33.33f, 40.29f)
                curveTo(34.75f, 40.51f, 36.25f, 40.48f, 37.57f, 41.06f)
                curveTo(38.88f, 41.64f, 39.96f, 43.16f, 39.43f, 44.49f)
                curveTo(39.17f, 45.14f, 38.6f, 45.6f, 38.02f, 45.98f)
                curveTo(35.59f, 47.58f, 32.66f, 48.24f, 30.08f, 49.6f)
                curveTo(26.98f, 51.24f, 24.51f, 53.97f, 23.02f, 57.14f)
                curveTo(21.7f, 59.95f, 21.03f, 63.34f, 21.62f, 66.43f)
                curveTo(22.17f, 69.27f, 24.99f, 71.3f, 27.88f, 70.1f)
                curveTo(28.52f, 69.84f, 29.03f, 69.4f, 29.45f, 68.88f)
                curveTo(28.82f, 68.75f, 28.22f, 68.47f, 27.68f, 68.05f)
                curveTo(25.29f, 66.21f, 25.11f, 61.8f, 30.5f, 54.92f)
                curveTo(34.85f, 49.37f, 39.41f, 49.71f, 42.19f, 47.3f)
                curveTo(42.21f, 47.28f, 42.23f, 47.26f, 42.26f, 47.24f)
                curveTo(42.25f, 47.25f, 42.24f, 47.26f, 42.23f, 47.27f)
                curveTo(42.37f, 47.15f, 42.5f, 47.02f, 42.62f, 46.89f)
                curveTo(41.79f, 48.13f, 41.48f, 49.38f, 41.25f, 50.82f)
                curveTo(41.35f, 50.74f, 41.44f, 50.65f, 41.53f, 50.56f)
                curveTo(42.15f, 49.86f, 42.6f, 49.01f, 43.28f, 48.37f)
                curveTo(43.95f, 47.72f, 45f, 47.31f, 45.83f, 47.73f)
                curveTo(46.72f, 48.19f, 46.96f, 49.34f, 47.01f, 50.34f)
                curveTo(47.25f, 54.99f, 45.74f, 59.55f, 43.95f, 63.85f)
                curveTo(42.04f, 68.44f, 39.71f, 72.96f, 36.18f, 76.46f)
                curveTo(32.65f, 79.96f, 30.29f, 82.6f, 19.69f, 82.16f)
                curveTo(28.24f, 87.17f, 40.55f, 83.57f, 46.44f, 71.29f)
                curveTo(52.29f, 59.09f, 52.72f, 48.73f, 50.42f, 46.44f)
                curveTo(48.55f, 44.58f, 45.57f, 43.49f, 43.33f, 45.99f)
                curveTo(45.86f, 42.03f, 43.67f, 40.06f, 40.66f, 39.09f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFF99F8))) {
                moveTo(15.91f, 75.23f)
                curveTo(17.78f, 77.46f, 20.48f, 78.91f, 23.33f, 79.48f)
                curveTo(25.98f, 80f, 29.05f, 79.65f, 30.9f, 77.62f)
                curveTo(31.87f, 76.56f, 32.33f, 74.73f, 31.29f, 73.76f)
                curveTo(30.4f, 72.93f, 29f, 73.19f, 27.8f, 73.36f)
                curveTo(25.8f, 73.64f, 23.71f, 73.49f, 21.9f, 72.63f)
                curveTo(20.08f, 71.77f, 18.59f, 70.12f, 18.19f, 68.14f)
                curveTo(17.77f, 66.08f, 18.53f, 63.99f, 19.06f, 61.95f)
                curveTo(19.26f, 61.2f, 19.38f, 60.27f, 18.79f, 59.79f)
                curveTo(18.05f, 59.18f, 16.94f, 59.85f, 16.29f, 60.57f)
                curveTo(12.54f, 64.73f, 12.34f, 70.96f, 15.91f, 75.23f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(15.39f, 71.49f)
                curveTo(15.26f, 71.75f, 15.35f, 72.05f, 15.45f, 72.32f)
                curveTo(16.77f, 75.72f, 20.46f, 78.02f, 24.01f, 78.15f)
                curveTo(24.72f, 78.18f, 25.48f, 78.12f, 26.04f, 77.69f)
                curveTo(26.6f, 77.26f, 26.81f, 76.33f, 26.3f, 75.85f)
                curveTo(26.02f, 75.58f, 25.61f, 75.51f, 25.23f, 75.46f)
                curveTo(24.56f, 75.36f, 23.9f, 75.27f, 23.23f, 75.17f)
                curveTo(21.51f, 74.92f, 19.67f, 74.62f, 18.4f, 73.44f)
                curveTo(17.93f, 73.01f, 17.56f, 72.48f, 17.18f, 71.97f)
                curveTo(16.96f, 71.67f, 16.71f, 71.36f, 16.37f, 71.22f)
                curveTo(16.03f, 71.08f, 15.56f, 71.16f, 15.39f, 71.49f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE874DA))) {
                moveTo(49.69f, 36.56f)
                curveTo(47.81f, 39.34f, 49.59f, 41.97f, 51.85f, 43.34f)
                curveTo(54.62f, 45.02f, 64.57f, 42.11f, 75f, 33.48f)
                curveTo(86.75f, 23.77f, 86.01f, 8.88f, 76.31f, 2.62f)
                curveTo(65.52f, -4.33f, 53.18f, 3.6f, 46.28f, 14.17f)
                curveTo(39.37f, 24.74f, 40.8f, 33.14f, 42.36f, 35.64f)
                curveTo(44.02f, 38.33f, 46.47f, 39.98f, 49.69f, 36.56f)
                curveTo(52.92f, 33.14f, 50.27f, 28.37f, 55.27f, 21.96f)
                curveTo(60.64f, 15.07f, 64.96f, 14.19f, 67.33f, 16.06f)
                curveTo(70.12f, 18.26f, 69.64f, 22.77f, 63.01f, 28.31f)
                curveTo(56.37f, 33.84f, 52.49f, 32.44f, 49.69f, 36.56f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC465BD))) {
                moveTo(42.36f, 35.64f)
                curveTo(41.55f, 34.34f, 40.78f, 31.47f, 41.18f, 27.54f)
                curveTo(41.25f, 27.57f, 41.31f, 27.61f, 41.37f, 27.65f)
                curveTo(41.55f, 27.8f, 41.66f, 28.02f, 41.75f, 28.24f)
                curveTo(42.31f, 29.56f, 42.63f, 31.02f, 43.52f, 32.16f)
                curveTo(44.4f, 33.3f, 46.13f, 33.98f, 47.3f, 33.14f)
                curveTo(47.86f, 32.74f, 48.17f, 32.07f, 48.4f, 31.42f)
                curveTo(49.37f, 28.67f, 49.3f, 25.67f, 50f, 22.84f)
                curveTo(50.85f, 19.43f, 52.9f, 16.38f, 55.61f, 14.17f)
                curveTo(58.02f, 12.21f, 61.15f, 10.74f, 64.29f, 10.57f)
                curveTo(67.18f, 10.42f, 69.84f, 12.66f, 69.37f, 15.76f)
                curveTo(69.27f, 16.44f, 68.97f, 17.04f, 68.56f, 17.58f)
                curveTo(68.28f, 16.99f, 67.87f, 16.48f, 67.33f, 16.05f)
                curveTo(64.96f, 14.19f, 60.64f, 15.07f, 55.27f, 21.96f)
                curveTo(50.93f, 27.53f, 52.36f, 31.86f, 50.69f, 35.15f)
                curveTo(50.68f, 35.17f, 50.66f, 35.2f, 50.65f, 35.22f)
                curveTo(50.65f, 35.21f, 50.66f, 35.2f, 50.67f, 35.19f)
                curveTo(50.59f, 35.35f, 50.49f, 35.51f, 50.4f, 35.66f)
                curveTo(51.4f, 34.55f, 52.54f, 33.95f, 53.88f, 33.38f)
                curveTo(53.83f, 33.5f, 53.76f, 33.61f, 53.69f, 33.71f)
                curveTo(53.17f, 34.49f, 52.45f, 35.13f, 51.99f, 35.94f)
                curveTo(51.53f, 36.75f, 51.38f, 37.87f, 51.99f, 38.57f)
                curveTo(52.65f, 39.33f, 53.82f, 39.28f, 54.8f, 39.09f)
                curveTo(59.38f, 38.2f, 63.44f, 35.64f, 67.18f, 32.86f)
                curveTo(71.17f, 29.89f, 75f, 26.55f, 77.54f, 22.28f)
                curveTo(80.09f, 18.01f, 82.07f, 15.08f, 79.1f, 4.9f)
                curveTo(86.02f, 11.99f, 85.5f, 24.8f, 75f, 33.48f)
                curveTo(64.57f, 42.1f, 54.62f, 45.02f, 51.85f, 43.33f)
                curveTo(49.59f, 41.97f, 47.81f, 39.34f, 49.69f, 36.56f)
                curveTo(46.47f, 39.98f, 44.02f, 38.33f, 42.36f, 35.64f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFF99F8))) {
                moveTo(71.45f, 2.91f)
                curveTo(74.07f, 4.18f, 76.13f, 6.45f, 77.37f, 9.08f)
                curveTo(78.52f, 11.52f, 78.92f, 14.59f, 77.4f, 16.88f)
                curveTo(76.6f, 18.08f, 74.93f, 18.96f, 73.74f, 18.19f)
                curveTo(72.72f, 17.52f, 72.64f, 16.1f, 72.51f, 14.89f)
                curveTo(72.3f, 12.88f, 71.65f, 10.89f, 70.38f, 9.34f)
                curveTo(69.1f, 7.79f, 67.15f, 6.74f, 65.12f, 6.83f)
                curveTo(63.03f, 6.92f, 61.18f, 8.16f, 59.33f, 9.17f)
                curveTo(58.65f, 9.54f, 57.78f, 9.87f, 57.17f, 9.42f)
                curveTo(56.4f, 8.85f, 56.78f, 7.61f, 57.32f, 6.81f)
                curveTo(60.45f, 2.17f, 66.46f, 0.47f, 71.45f, 2.91f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(67.7f, 3.3f)
                curveTo(67.92f, 3.12f, 68.24f, 3.12f, 68.52f, 3.16f)
                curveTo(72.14f, 3.62f, 75.26f, 6.64f, 76.25f, 10.06f)
                curveTo(76.44f, 10.74f, 76.57f, 11.49f, 76.29f, 12.14f)
                curveTo(76.01f, 12.78f, 75.15f, 13.22f, 74.56f, 12.83f)
                curveTo(74.23f, 12.63f, 74.07f, 12.25f, 73.93f, 11.89f)
                curveTo(73.67f, 11.27f, 73.42f, 10.64f, 73.16f, 10.02f)
                curveTo(72.51f, 8.41f, 71.77f, 6.7f, 70.32f, 5.75f)
                curveTo(69.79f, 5.4f, 69.18f, 5.17f, 68.6f, 4.92f)
                curveTo(68.25f, 4.78f, 67.9f, 4.61f, 67.68f, 4.32f)
                curveTo(67.45f, 4.02f, 67.42f, 3.55f, 67.7f, 3.3f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE874DA))) {
                moveTo(51.49f, 45.03f)
                curveTo(48.36f, 43.82f, 46.19f, 46.14f, 45.37f, 48.64f)
                curveTo(44.35f, 51.72f, 49.4f, 60.77f, 60.13f, 69.02f)
                curveTo(72.21f, 78.31f, 86.56f, 74.27f, 90.5f, 63.43f)
                curveTo(94.88f, 51.36f, 84.4f, 41.09f, 72.56f, 36.72f)
                curveTo(60.72f, 32.34f, 52.85f, 35.61f, 50.76f, 37.67f)
                curveTo(48.51f, 39.9f, 47.44f, 42.65f, 51.49f, 45.03f)
                curveTo(55.54f, 47.42f, 59.61f, 43.77f, 66.96f, 47.22f)
                curveTo(74.88f, 50.93f, 76.7f, 54.94f, 75.41f, 57.66f)
                curveTo(73.88f, 60.87f, 69.37f, 61.41f, 62.5f, 56.17f)
                curveTo(55.63f, 50.94f, 56.13f, 46.84f, 51.49f, 45.03f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC465BD))) {
                moveTo(50.76f, 37.67f)
                curveTo(51.84f, 36.6f, 54.47f, 35.22f, 58.39f, 34.73f)
                curveTo(58.38f, 34.8f, 58.36f, 34.87f, 58.32f, 34.94f)
                curveTo(58.22f, 35.15f, 58.03f, 35.3f, 57.84f, 35.43f)
                curveTo(56.67f, 36.28f, 55.32f, 36.92f, 54.41f, 38.03f)
                curveTo(53.49f, 39.15f, 53.21f, 40.99f, 54.29f, 41.94f)
                curveTo(54.81f, 42.4f, 55.53f, 42.55f, 56.22f, 42.63f)
                curveTo(59.11f, 42.96f, 62.03f, 42.23f, 64.94f, 42.28f)
                curveTo(68.45f, 42.34f, 71.88f, 43.67f, 74.64f, 45.82f)
                curveTo(77.09f, 47.74f, 79.22f, 50.46f, 80.08f, 53.48f)
                curveTo(80.87f, 56.26f, 79.27f, 59.36f, 76.15f, 59.59f)
                curveTo(75.46f, 59.64f, 74.81f, 59.48f, 74.2f, 59.2f)
                curveTo(74.71f, 58.8f, 75.11f, 58.28f, 75.41f, 57.66f)
                curveTo(76.7f, 54.94f, 74.88f, 50.93f, 66.96f, 47.22f)
                curveTo(60.58f, 44.23f, 56.67f, 46.59f, 53.09f, 45.69f)
                curveTo(53.06f, 45.68f, 53.04f, 45.67f, 53.01f, 45.66f)
                curveTo(53.02f, 45.67f, 53.03f, 45.67f, 53.04f, 45.68f)
                curveTo(52.87f, 45.63f, 52.7f, 45.58f, 52.52f, 45.52f)
                curveTo(53.83f, 46.25f, 54.67f, 47.22f, 55.52f, 48.4f)
                curveTo(55.4f, 48.39f, 55.27f, 48.35f, 55.16f, 48.3f)
                curveTo(54.29f, 47.96f, 53.5f, 47.4f, 52.61f, 47.13f)
                curveTo(51.71f, 46.86f, 50.59f, 46.96f, 50.04f, 47.72f)
                curveTo(49.45f, 48.53f, 49.76f, 49.66f, 50.17f, 50.58f)
                curveTo(52.05f, 54.84f, 55.45f, 58.23f, 58.99f, 61.25f)
                curveTo(62.77f, 64.48f, 66.88f, 67.47f, 71.61f, 69f)
                curveTo(76.34f, 70.53f, 79.64f, 71.82f, 88.9f, 66.65f)
                curveTo(83.53f, 74.98f, 70.93f, 77.32f, 60.13f, 69.02f)
                curveTo(49.4f, 60.77f, 44.35f, 51.72f, 45.37f, 48.64f)
                curveTo(46.19f, 46.14f, 48.36f, 43.82f, 51.49f, 45.03f)
                curveTo(47.44f, 42.65f, 48.51f, 39.9f, 50.76f, 37.67f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFF99F8))) {
                moveTo(89.14f, 58.76f)
                curveTo(88.48f, 61.59f, 86.73f, 64.11f, 84.45f, 65.9f)
                curveTo(82.31f, 67.56f, 79.41f, 68.63f, 76.85f, 67.66f)
                curveTo(75.5f, 67.15f, 74.27f, 65.72f, 74.76f, 64.38f)
                curveTo(75.18f, 63.24f, 76.54f, 62.85f, 77.7f, 62.45f)
                curveTo(79.6f, 61.8f, 81.41f, 60.73f, 82.63f, 59.14f)
                curveTo(83.86f, 57.55f, 84.45f, 55.41f, 83.91f, 53.46f)
                curveTo(83.36f, 51.44f, 81.74f, 49.9f, 80.34f, 48.33f)
                curveTo(79.83f, 47.75f, 79.31f, 46.98f, 79.61f, 46.28f)
                curveTo(80f, 45.4f, 81.29f, 45.5f, 82.2f, 45.85f)
                curveTo(87.42f, 47.87f, 90.41f, 53.34f, 89.14f, 58.76f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(58.84f, 39.7f)
                curveTo(59.24f, 40.08f, 59.88f, 40.01f, 60.43f, 39.91f)
                curveTo(61.34f, 39.73f, 62.27f, 39.54f, 63.2f, 39.58f)
                curveTo(64.23f, 39.63f, 65.22f, 39.97f, 66.23f, 40.18f)
                curveTo(67.24f, 40.39f, 68.34f, 40.47f, 69.27f, 40.03f)
                curveTo(69.38f, 39.98f, 69.5f, 39.91f, 69.57f, 39.8f)
                curveTo(69.7f, 39.58f, 69.57f, 39.29f, 69.42f, 39.09f)
                curveTo(68.21f, 37.52f, 64.83f, 37.06f, 62.95f, 36.93f)
                curveTo(61.91f, 36.86f, 56.9f, 37.86f, 58.84f, 39.7f)
                close()
            }
            path(fill = SolidColor(Color(0xFF72E55A))) {
                moveTo(52.59f, 41.14f)
                curveTo(52.16f, 44.98f, 48.68f, 47.75f, 44.84f, 47.32f)
                curveTo(40.99f, 46.89f, 38.22f, 43.42f, 38.65f, 39.57f)
                curveTo(39.08f, 35.72f, 42.55f, 32.95f, 46.4f, 33.38f)
                curveTo(50.25f, 33.82f, 53.02f, 37.29f, 52.59f, 41.14f)
                close()
            }
            path(fill = SolidColor(Color(0xFF6DCC52))) {
                moveTo(48.76f, 34.08f)
                curveTo(49.76f, 35.45f, 50.27f, 37.18f, 50.07f, 39f)
                curveTo(49.64f, 42.85f, 46.17f, 45.62f, 42.32f, 45.18f)
                curveTo(41.47f, 45.09f, 40.67f, 44.85f, 39.95f, 44.48f)
                curveTo(41.07f, 46.02f, 42.8f, 47.1f, 44.84f, 47.32f)
                curveTo(48.69f, 47.75f, 52.16f, 44.98f, 52.59f, 41.14f)
                curveTo(52.92f, 38.13f, 51.31f, 35.36f, 48.76f, 34.08f)
                close()
            }
            path(fill = SolidColor(Color(0xFF90FF7D))) {
                moveTo(41.26f, 41.54f)
                curveTo(41.72f, 42.03f, 42.31f, 42.38f, 42.92f, 42.65f)
                curveTo(43.6f, 42.94f, 44.35f, 43.13f, 45.08f, 42.99f)
                curveTo(46.06f, 42.81f, 46.86f, 42.02f, 47.3f, 41.11f)
                curveTo(47.75f, 40.21f, 47.9f, 39.2f, 48.04f, 38.2f)
                curveTo(48.37f, 35.88f, 44.79f, 34.53f, 42.83f, 35.22f)
                curveTo(40.31f, 36.12f, 39.43f, 39.61f, 41.26f, 41.54f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.53f,
                strokeAlpha = 0.53f
            ) {
                moveTo(43.32f, 36.51f)
                curveTo(42.63f, 36.39f, 42.06f, 37.1f, 41.89f, 37.78f)
                curveTo(41.77f, 38.24f, 41.76f, 38.75f, 42.01f, 39.15f)
                curveTo(42.29f, 39.59f, 42.83f, 39.8f, 43.35f, 39.87f)
                curveTo(44.25f, 39.98f, 45.26f, 39.7f, 45.75f, 38.93f)
                curveTo(46.16f, 38.28f, 46.08f, 37.35f, 45.56f, 36.78f)
                curveTo(45.05f, 36.21f, 44.13f, 36.04f, 43.44f, 36.38f)
                close()
            }
        }.build()

        return _Flower!!
    }

@Suppress("ObjectPropertyName")
private var _Flower: ImageVector? = null
